import { HttpClient, HttpContext, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { LOCAL_STORAGE_KEYS } from "../global/constant";
import { SharedService } from "./shared.service";

@Injectable({
  providedIn: "root",
})
export class CommonApiService {
  private readonly baseUrl = environment.apiUrl;
  constructor(private http: HttpClient, private sharedService: SharedService) { }

  post(url: string, data: any, extraHeaders?: Record<string, string>) {
    const companyId = this.sharedService.getCompanyId();
    let headers = new HttpHeaders();
    if (companyId) {
      headers = headers.set("company-id", companyId.toString());
    }
    if (extraHeaders) {
      for (const [key, value] of Object.entries(extraHeaders)) {
        if (value != null && value !== "") {
          headers = headers.set(key, value);
        }
      }
    }
    const options = headers.keys().length ? { headers } : undefined;
    return this.http.post(this.baseUrl + url, data, options);
  }

  /** `context` is optional; see `_helper/http-context-tokens.ts`. */
  get(url: string, queryParams?: HttpParams, context?: HttpContext) {
    const companyId = this.sharedService.getCompanyId();
    if (companyId) {
      const headers = new HttpHeaders({
        'company-id': companyId?.toString() || "",
      });
      return this.http.get(this.baseUrl + url, {
        params: queryParams,
        headers,
        context,
      });
    } else {
      return this.http.get(this.baseUrl + url, {
        params: queryParams,
        context,
      });
    }
  }

  update(url: string, data: any) {
    const companyId = this.sharedService.getCompanyId();
    if (companyId) {
      const headers = new HttpHeaders({
        'company-id': companyId?.toString() || "",
      });
      return this.http.put(this.baseUrl + url, data, { headers });
    } else {
      return this.http.put(this.baseUrl + url, data);
    }
  }

  patch(url: string, data: any) {
    const companyId = this.sharedService.getCompanyId();
    if (companyId) {
      const headers = new HttpHeaders({
        "company-id": companyId?.toString() || "",
      });
      return this.http.patch(this.baseUrl + url, data, { headers });
    }
    return this.http.patch(this.baseUrl + url, data);
  }

  delete(url: string, queryParams?: HttpParams) {
    return this.http.delete(this.baseUrl + url, {
      params: queryParams,
      headers: {
        'company-id': this.sharedService.getCompanyId()?.toString() || "",
      },
    });
  }

  public getParamsFromObj(obj: any): HttpParams {
    let params = new HttpParams();

    if (obj) {
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== "" && obj[key] !== undefined) {
          params = params.set(key, obj[key]);
        }
      });
    }
    return params;
  }

  postBlob(url: string, data: any) {
    const token = localStorage.getItem(LOCAL_STORAGE_KEYS.accessToken);

    return fetch(this.baseUrl + url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    });
  }

  getBlob(url: string) {
    const token = localStorage.getItem(LOCAL_STORAGE_KEYS.accessToken);
    return fetch(this.baseUrl + url, {
      method: "get",
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  }
}
